import {Component, inject, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {faTriangleExclamation, faXmark, faChevronRight, faPlus} from "@fortawesome/free-solid-svg-icons";
import {SystemManagementService} from "../../../data-access/system-management.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Pagination} from "../../../../exam/feature/exam-submissions/exam-submissions.component";
import {MenuItem} from "../../../../shared/ui/dropdown-menu/dropdown-menu.component";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";

interface Item {
  name: string,
  unit_id: number,
  subject_id: number
  items: MenuItem[]
}
@Component({
    selector: 'units-list',
    templateUrl: './unit-list.component.html',
    standalone: false
})
export class UnitListComponent implements OnInit {
  router = inject(Router)
  systemService = inject(SystemManagementService)
  _snackBar = inject(MatSnackBar)
  currentPagination: Pagination = {
    limit: 25,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }
  items: Item[] = []
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'System Management',
    route: 'dashboard/SystemManagement'
  }, {
    text: 'System Lists',
    route: 'dashboard/SystemManagement/lists'
  }]

  ngOnInit() {
    this.handleServiceCall()
  }

  handleServiceCall() {
    this.systemService.listUnits(this.currentPagination.limit, this.currentPagination.page).subscribe((response) => {
      if(response.success) {
        this.items = []
        for(let item of response.result.items) {
          this.items.push({
            ...item,
            items: [{
              title: 'Edit',
              route: 'dashboard/SystemManagement/units/config',
              queryParams: {queryParams: {unit_id: item.unit_id, subject_id: item.subject_id, name: item.name}}
            }]
          })
        }
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  systemManagementMenu() {
    this.router.navigate(['dashboard/SystemManagement'])
  }

  unitConfig() {
    // TODO add url param for edit
    this.router.navigate(['dashboard/SystemManagement/units/config'])
  }

  protected readonly faPlus = faPlus;
}
